import Vue from "vue";
import PaymentLineItem from "./paymentLineItem";
import PaymentLineItemAmount from "./paymentLineItemAmount";
import FormElementConditionalRuleSet from "../conditionalRules/formElementConditionalRuleSet";

export default class PaymentLineItemAmountFactory {
  static create(parent: PaymentLineItem | FormElementConditionalRuleSet): PaymentLineItemAmount {
    return PaymentLineItemAmountFactory.createFor(parent,
      parent instanceof PaymentLineItem ? 'amount' : 'conditional_value');
  }

  private static createFor(parent: PaymentLineItem | FormElementConditionalRuleSet, fieldName: string) {
    const paymentLineItemAmount: PaymentLineItemAmount = new PaymentLineItemAmount();

    paymentLineItemAmount.defineProperty('payment_amount', 0);
    paymentLineItemAmount.defineProperty('skip_charge', false);

    paymentLineItemAmount.parent = parent;
    Vue.set(parent, fieldName, paymentLineItemAmount);

    return paymentLineItemAmount;
  }
}